<template>
  <div class="homeContainer">
    <el-container>
      <el-header>
        <div class="nav_wrapepr">
          <div class="nav_left">
            <a
              style="height:60px;"
              target="_blank"
              href="http://www.jinyafu.com/"
            >
              <img
                src="../assets/image/jinyafuLogo.jpg"
                style="max-width: 150px;height:60px;"
              />
            </a>
            <span
              v-for="(item, index) in navlist"
              :key="index"
              @click="changeRouter(item)"
              >{{ item }}</span
            >
          </div>
          <div class="nav_right">
            <span
              ><a
                href="http://www.jinyafu.com/"
                target="_blank"
                style="text-decoration: none; color: rgb(0, 0, 0);"
                >进入官网</a
              ></span
            >
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div>
          深圳金雅福控股集团有限公司版权所有 粤ICP备12004558号Copyright ©
          2011-2020 Kinghood Group All Rights Reserved. 粤公网安备
          44030302001052号
          <span>—— 黄金生活，优雅幸福</span>
        </div>
        <div>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302001052"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
            target="_blank"
            ><img
              alt=""
              src="http://www.jinyafu.com:81/upload/images/20180928_164318.png"
              style="width: 20px; height: 20px;"
            />粤公网安备 44030302001052号</a
          >
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      navlist: ['首页', '社会招聘', '校园招聘'],
    };
  },
  methods: {
    changeRouter(params) {
      if (params === '首页') {
        this.$router.push({ name: 'Index' });
      } else {
        let code = 0;
        if (params === '社会招聘') {
          code = 2;
        } else if (params === '校园招聘') {
          code = 1;
        }
        this.$router.push({ name: 'RecruitmentList', query: { type: code } });
      }
    },
  },
};
</script>
<style lang="scss">
.homeContainer {
  height: 100%;
  .el-container {
    height: 100%;
    .el-header {
      padding: 0;
      line-height: 60px;
      display: flex;
      justify-content: center;
      .nav_wrapepr {
        width: 1500px;
        .nav_left {
          float: left;
          img {
            max-width: 150px;
            height: 60px;
            cursor: pointer;
          }
          span {
            cursor: pointer;
            width: 32px;
            padding: 10px;
            margin: 5px;
            font-size: 16px;
          }
        }
        .nav_right {
          float: right;
          span {
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
    .el-footer {
      overflow: hidden;
      background: rgb(111, 80, 20);
      text-align: center;
      line-height: 30px;
      color: #999;
      font-size: 12px;
      span {
        margin-left: 50px;
      }
    }

    .el-main {
      padding: 0;
      background: #e9e9e9;
    }
  }
}
</style>
